export default __webpack_public_path__ + "static/media/te3.0a278301.png";